<template>
  <div v-if="manufacturer === 'Kenworth'" class="faq-container">
    <div class="blog-card">
      <p class="answer">
        Kenworth was founded in 1923 and specializes in the manufacture of
        heavy-duty commercial trucks. Kenworth is a subsidiary of PACCAR.
        Kenworth manufacturers several models of semi trucks with sleeper cabs
        that are often categorized on Dealer inventory aggregation websites as
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=1"
          >conventional w/ sleeper trucks for sale</router-link
        >. Kenworth heavy-duty commercial trucks typically have good resale
        value. The most popular models of new and used Kenworth semi trucks
        currently for sale include the
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth&model=T660"
          >Kenworth T660</router-link
        >,
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth&model=T680"
          >Kenworth T680</router-link
        >,
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth&model=T880"
        >
          Kenworth T880</router-link
        >, and the
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth&model=W900"
          >Kenworth W900</router-link
        >, and are listed together as
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth"
          >sleeper trucks for sale</router-link
        >
        on this site.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        Kenworth has manufactured over 100,000 T680’s since 2012. The T680 model
        has a larger sleeper cab than the T660, adding to driver comfort. In
        addition, the T680 delivers about a 10% increase in fuel efficiency over
        the older T660 model. The recently released Kenworth T680 Next
        Generation model has demonstrated up to 6% increased fuel efficiency
        when equipped with a 76-inch sleeper and 2021 PACCAR MX-13 motor over a
        comparable prior year T680 equipped with an 2017 PACCAR MX-13 engine.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        It is easy to shop and compare
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth"
          >new and used Kenworth semi trucks for sale</router-link
        >
        on SleeperTrader. Simply click the filter at the top of any of the semi
        trucks for sale aggregation pages and select Kenworth. That will display
        hundreds of
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Kenworth"
          >Kenworth sleeper trucks for sale</router-link
        >
        by Dealers around the US. Feel free to call or email any of those
        Dealers for more information about the truck or trucks you are
        interested in purchasing. Many of the Dealers that advertise their
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=5"
          >semi trucks for sale</router-link
        >
        on our site will have commercial truck financing options to help you
        with the purchase of your new truck.
      </p>
    </div>
  </div>
  <div v-else-if="manufacturer === 'Peterbilt'" class="faq-container">
    <div class="blog-card">
      <p class="answer">
        Peterbilt Motors Company was founded in 1939 and specializes in the
        manufacture of heavy-duty commercial trucks. Peterbilt is a subsidiary
        of PACCAR. Peterbilt manufacturers several models of semi trucks with
        sleeper cabs that are often categorized on Dealer inventory aggregation
        websites as
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=1"
          >conventional w/ sleeper trucks for sale</router-link
        >. Peterbilt heavy-duty commercial trucks typically have good resale
        value. The most popular models of new and used Peterbilt semi trucks for
        sale are the
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Peterbilt&model=579"
          >Peterbilt 579</router-link
        >, and are listed together as
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Peterbilt"
          >sleeper trucks for sale</router-link
        >
        on this site.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        Peterbilt has manufactured the Model 579 for several years. The design
        features of the Peterbilt 579 combine reliability and aerodynamics to
        deliver a practical and fuel efficient experience for owners. The “New
        Model 579”, as Peterbilt likes to call the latest version, has the more
        aerodynamic front end requiring Peterbilt to lower the radiator and
        stiffen the truck’s chassis. These enhancements support 1,500 rpm
        highway cruising and deliver an improved ride with a quieter cab.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        It is easy to shop and compare
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Peterbilt"
          >new and used Peterbilt semi trucks for sale</router-link
        >
        on SleeperTrader. Simply click the filter at the top of any of the semi
        trucks for sale aggregation pages and select Peterbilt. That will
        display hundreds of
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=Peterbilt"
          >Peterbilt sleeper trucks for sale</router-link
        >
        by Dealers around the US. Feel free to call or email any of those
        Dealers for more information about the truck or trucks you are
        interested in purchasing. Many of the Dealers that advertise their
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=5"
          >semi trucks for sale</router-link
        >
        on our site will have commercial truck financing options to help you
        with the purchase of your new truck.
      </p>
    </div>
  </div>
  <div v-else-if="manufacturer === 'International'" class="faq-container">
    <div class="blog-card">
      <p class="answer">
        Navistar International Corporation is the successor to International
        Harvester and manufactures heavy-duty commercial semi trucks. Navistar
        International manufacturers several models of semi trucks with sleeper
        cabs that are often categorized on Dealer inventory aggregation websites
        as
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=1"
          >conventional w/ sleeper trucks for sale</router-link
        >. The current models of International heavy-duty commercial trucks
        typically have good resale value. The most popular models of new and
        used International semi trucks for sale include the
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International&model=LoneStar"
          >International LoneStar</router-link
        >,
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International&model=ProStar"
          >International ProStar</router-link
        >
        and the
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International&model=LT"
          >International LT</router-link
        >
        and are listed together as
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International"
          >sleeper trucks for sale</router-link
        >
        on this site.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        The International LT Series offers four sleeper configurations and was
        designed to improve aerodynamic air flow to optimize fuel efficiency.
        Better fuel mileage means more money in your pocket! Add in that the LT
        series is customizable with a “build your own” option means you can get
        a truck equipped the way you need it to be equipped. The LT Series
        offers improved positioning of Driver controls as well as an available
        collision mitigation system.
      </p>
    </div>
    <div class="blog-card">
      <p class="answer">
        It is easy to shop and compare
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International"
          >new and used International semi trucks for sale</router-link
        >
        on SleeperTrader. Simply click the filter at the top of any of the semi
        trucks for sale aggregation pages and select International. That will
        display hundreds of
        <router-link
          class="a-underline-grey-5"
          to="/trucks-for-sale?page=1&manufacturer=International"
          >International sleeper trucks for sale</router-link
        >
        by Dealers around the US. Feel free to call or email any of those
        Dealers for more information about the truck or trucks you are
        interested in purchasing. Many of the Dealers that advertise their
        <router-link class="a-underline-grey-5" to="/trucks-for-sale?page=5"
          >semi trucks for sale</router-link
        >
        on our site will have commercial truck financing options to help you
        with the purchase of your new truck.
      </p>
    </div>
  </div>
</template>

<script>
  export default { props: { manufacturer: { Type: String } } }
</script>
